import React, { useEffect, useState } from "react";

import axios from "axios";
import cup from "../../../../../../../../assets/images/cup 2.png";
import AuditionCardReuse from "../../../../../../../AuditionAdmin/AuditionCardReuse";
import AllDataHeader from "../../../../../../../Reuseable/AllDataHeader";
import EventsNav from "./EventsNav";
import LoaderPost from "../../../../../../../Reuseable/LoaderPost";

const EventsLive = () => {
  const [events, setEvents] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/audition-admin/audition/lives").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setEvents(res.data.lives);
      }
    });
  }, []);

  return (
    <>
      <EventsNav />
   
      <AllDataHeader title="live auditions " image={cup} count={"Zero"} />

      {buffer ? (
        <LoaderPost />
      ) : (
        <AuditionCardReuse
          data={events}
          urlLinkInstruction={`/audition-admin/audition/round-instruction`}
          urlLinkFeedback={`/audition-admin/audition/star-feedback-round-instruction`}
        />
      )}
    </>
  );
};

export default EventsLive;
